document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("custom-review-popup");
    const openBtn = document.getElementById("review-btn");
    const closeBtn = document.getElementById("review-close");
    const overlay = document.querySelector(".custom-review-overlay");

    const reviewList = document.getElementById("review-list");
    const searchInput = document.getElementById("review-search");

    const averageRating = document.getElementById("average-rating");
    const totalReview = document.getElementById("total-review");
    const ratingFilter = document.getElementById("rating-filter");

    let reviews = [];

    try {

        reviews = JSON.parse(
            document.getElementById("review-json").textContent
        );

    } catch (e) {

        console.error("Review JSON Error", e);

    }

    /*==========================
      Popup
    ==========================*/

openBtn.addEventListener("click", function(){

    popup.classList.add("active");

    overlay.style.display = "block";

    document.body.style.overflow = "hidden";

});

function closePopup(){

    popup.classList.remove("active");

    overlay.style.display = "none";

    document.body.style.overflow = "";

}

    closeBtn.addEventListener("click", closePopup);

    overlay.addEventListener("click", closePopup);

    document.addEventListener("keydown", function(e){

        if(e.key==="Escape"){

            closePopup();

        }

    });

    /*==========================
      Average
    ==========================*/

    function updateSummary(data){

        totalReview.innerHTML=data.length+" Reviews";

        if(data.length===0){

            averageRating.innerHTML="0.0";

            return;

        }

        let total=0;

        data.forEach(function(r){

            total+=parseInt(r.rating);

        });

        averageRating.innerHTML=(total/data.length).toFixed(1);

    }

    
    /*==========================
      Stars
    ==========================*/

    function stars(num){

        let html="";

        for(let i=1;i<=5;i++){

            html+= i<=num ? "★" : "☆";

        }

        return html;

    }



    function formatDate(dateString){

    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {

        day: "2-digit",

        month: "short",

        year: "numeric"

    });

}

    /*==========================
      Render
    ==========================*/

    function render(list){

        reviewList.innerHTML="";

        updateSummary(list);

        if(list.length===0){

            reviewList.innerHTML="<h3>No Reviews Found</h3>";

            return;

        }

        list.forEach(function(item){

            let verified="";

            if(item.verified){

                verified='<div style="color:green;font-size:14px;margin-top:5px;">✔ Verified Purchase</div>';

            }

            let image="";

            if(item.customer_image!=""){

                image=`
                    <img
                    src="${item.customer_image}"
                    class="review-avatar">
                `;

            }

            reviewList.innerHTML+=`

            <div class="review-card">

                <div class="review-top">

                    ${image}

                    <div>

                        <div class="review-name">

                            ${item.name}

                        </div>

                        <div class="review-stars">

                            ${stars(item.rating)}

                        </div>

                        ${verified}

                      <div class="review-date">
    ${formatDate(item.date)}
</div>

                    </div>

                </div>

                <div class="review-title-text">

                    ${item.title}

                </div>

                <div class="review-description">

                    ${item.description}

                </div>

            </div>

            `;

        });

    }

    render(reviews);

    /*==========================
      Search
    ==========================*/

    searchInput.addEventListener("keyup",function(){

        let value=this.value.toLowerCase();

        let filtered=reviews.filter(function(item){

            return item.name.toLowerCase().includes(value)

            ||

            item.title.toLowerCase().includes(value)

            ||

            item.description.toLowerCase().includes(value);

        });

        render(filtered);

    });

    /*==========================
      Rating Filter
    ==========================*/

    for(let i=5;i>=1;i--){

        let btn=document.createElement("button");

        btn.className="rating-btn";

        btn.innerHTML=i+" ★";

        btn.dataset.rating=i;

        ratingFilter.appendChild(btn);

    }

    document.querySelectorAll(".rating-btn").forEach(function(btn){

        btn.addEventListener("click",function(){

            document.querySelectorAll(".rating-btn").forEach(function(b){

                b.classList.remove("active");

            });

            this.classList.add("active");

            let rating=parseInt(this.dataset.rating);

            let filtered=reviews.filter(function(item){

                return parseInt(item.rating)===rating;

            });

            render(filtered);

        });

    });

});